export default function toSnakeCase(str: string): string {
	return str.toLowerCase().replace(/ /g, '_');
}
